<div *ngIf="product" class="d-flex align-items-center">
  <div *ngIf="image" class="product-icon me-3 d-flex justify-content-center align-items-center">
    <cx-media [alt]="image.altText" [container]="{url: image.url}"
              [title]="image.altText"></cx-media>
  </div>
  <div class="d-flex flex-column">
    <div class="breadcrumbs-menu d-flex align-items-center position-absolute">
      <div (click)="launchSearchResult()"
          class="breadcrumbs-menu-link ds-color--grey-1 ds-fine-print ds-cursor--pointer"
          tabindex="0">
        {{'productDetails.allProducts' | cxTranslate}}
      </div>
      <span class="separator">&#47;</span>
      <ng-container *ngIf="categories.length > 0">
        <div (click)="showProductsForCategory(displayedCategory.code)"
              class="breadcrumbs-menu-link ds-color--grey-1 ds-fine-print ds-cursor--pointer"
              tabindex="0">
          {{displayedCategory.name}}
        </div>
      </ng-container>
    </div>
    <dcp-limited-text
      [charLimit]="110"
      [minimumHiddenText]="0"
      [showMoreOption]="false"
      [text]="product.name"
      class="product-title ds-heading--s ds-font--medium mb-0">
    </dcp-limited-text>
    <div *ngIf="product.vendor" class="d-flex flex-nowrap ds-fine-print ds-color--grey-2">
      <span>{{'productDetails.by' | cxTranslate}}</span>
      <span class="ms-1">{{product.vendor.name}}</span>
    </div>
  </div>
</div>
